import Heading from '/components/ui/typography/Heading';
import Paragraph from '/components/ui/typography/Paragraph';
import Image from '/types/imageType';
import FileInput from '/components/ui/FileInput';

interface Props {
    images: Image[];
    onChange: (images: Image[]) => void;
}

export default function JobImages({ images, onChange }: Props) {
    return (
        <>
            <Heading as="div" size="medium" className="mb-12">
                Bilder
            </Heading>
            <Paragraph size="small" weight="weak" className="mb-24">
                Last opp eventuelle bilder
            </Paragraph>
            <FileInput
                id="job-custom-images"
                maxFiles={10}
                files={images || []}
                lightbox
                customerUpload
                onUpload={(images: Image[]) => onChange(images)}
                className="mb-80"
            />
        </>
    );
}
